import TargetingSelection from './TargetingSelection';

export default TargetingSelection;
